import {
  ChevronRightIcon,
  IndianRupee,
  LinkIcon,
  MoveRight,
  SquareArrowOutUpRight,
} from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ErrorMessage, Field, Form, Formik } from "formik";
// import {
//   cancelSignDocument,
//   digioSignedUpdatePayment,
//   getKYCDetails,
//   paymentOnCashFree,
//   paymentRequest,
//   requestSignDocument,
//   updateRazorpaySuccess,
// } from "../pages/service/trading-investing/TradingInvesting.service";
// import {
//   CASHFREE_ENV,
//   DIGIO_ENV,
//   RAZORPAY_KEY,
//   V1_API_ORIGIN,
// } from "../config/constants.config";
import axios from "axios";
import states from "../state.json";
// import OffCanvasRight from "../pages/layout/interface/off-canvas-right";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
// import { handleScrollToTop } from "./Common";
import { getCashfree } from "../../utils/cashfree";
import toast, { Toaster } from "react-hot-toast";
import { DIGIO_ENV, V1_API_ORIGIN } from "../../config/constants.config";
import axiosInstance from "../../api/axiosInstance";
import { requestSignDocument, digioSignedUpdatePayment, getKYCDetails, paymentOnCashFree, paymentRequest, cancelSignDocument } from "../../api/pricing";

export const MakePaymentProcess = ({
  planData,
  componentKey,
  total,
  gst,
  grandTotal,
  isPaymentRequest,
  paymentId,
  sourceData,
  pageData,
  btnName,
  hasPerformance,
  IsRecurringOptionOpen
}) => {
  const authState = useSelector((state) => state.auth.authState);
  const userDetail = useSelector((state) => state.auth.userDetail);
  const rpfId = useSelector((state) => state.auth.userDetail.rpfId);
  const [hasUserDataBeforePayment, setHasUserDataBeforePayment] = useState({
    cusCountry: "INDIA",
    cusState: "",
    cusCity: "",
  });
  const [digioSignUpdate, setDigioSignUpdate] = useState({
    status: "",
    details: {},
  });

  const [isKycFilled, setIsKycFilled] = useState(false);
  const [hasErrorMessage, setHasErrorMessage] = useState(false);
  const [requestSignData, setRequestSignData] = useState({});
  const [hasKycData, setHasKycData] = useState({});
  const buttonRef = useRef();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [OffCanvas, setOffCanvas] = useState(false);
  const [InitializeCashfree, setInitializeCashfree] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleOffCanvasToggle = () => {
    setOffCanvas((prev) => false);
  };
  const doPayment = async (payId) => {
    const cashfree = await getCashfree();
    let checkoutOptions = {
      paymentSessionId: payId,
      redirectTarget: "_modal",
    };
    // console.log(checkoutOptions);

    cashfree.checkout(checkoutOptions).then((result) => {
      if (result.error) {
        // handleScrollToTop();
        navigate("/txn/failure");
        setInitializeCashfree(false);
        // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
        console.log(
          "User has closed the popup or there is some payment error, Check for Payment Status"
        );
        console.log(result.error);
      }
      if (result.redirect) {
        setInitializeCashfree(false);
        // This will be true when the payment redirection page couldnt be opened in the same window
        // This is an exceptional case only when the page is opened inside an inAppBrowser
        // In this case the customer will be redirected to return url once payment is completed
        console.log("Payment will be redirected");
      }
      if (result.paymentDetails) {
        localStorage.setItem("pid", window.paymentID);
        localStorage.removeItem("cz");
        axiosInstance.post(`${V1_API_ORIGIN}/payments/${window.paymentID}`, {
          payStatus: "success",
        });
        setInitializeCashfree(false);
        // router("/txn/success");
        navigate("/my-services");
        // window.location.reload();
        // handleScrollToTop();
        // This will be called whenever the payment is completed irrespective of transaction status
        console.log("Payment has been completed, Check for Payment Status");
        console.log(result.paymentDetails.paymentMessage);
      }
    });
  };

  useEffect(() => {
    if (showModal) {
      const modalBackdrop = document.querySelector(".modal-backdrop");
      if (modalBackdrop) {
        modalBackdrop.addEventListener("click", handleClose);
      }

      return () => {
        if (modalBackdrop) {
          modalBackdrop.removeEventListener("click", handleClose);
        }
      };
    }
  }, [showModal]);
  useEffect(() => {
    if (typeof requestSignData.id !== "undefined") {
      window.paymentID = requestSignData.paymentId;
      const digio = new window.Digio({
        environment: DIGIO_ENV,
        callback: async (response) => {
          if (
            response.hasOwnProperty("error_code") &&
            response.error_code === "CANCELLED"
          ) {
            setDigioSignUpdate((prevState) => ({
              ...prevState,
              status: "CANCELLED",
              details: { ...response, paymentID: window.paymentID },
            }));
            setShowModal(false);
          } else {
            setDigioSignUpdate((prevState) => ({
              ...prevState,
              status: "SUCCESS",
              details: { ...response, paymentID: window.paymentID },
            }));
            setShowModal(false);
          }
        },
        theme: {
          darkColor: "#AB3498",
          secondaryColor: "#000000",
        },
        Is_redirection_approach: false,
        is_iframe: true,
      });
      digio.init();
      digio.submit(
        requestSignData.id,
        requestSignData.signing_parties[0]?.identifier,
        requestSignData.access_token?.id
      );
    }
  }, [requestSignData]);

  useEffect(() => {
    const finalDiscountPrice =
      planData === null ? 0 : Object.values(planData)[0]?.discountPrice;
    const finalGST = finalDiscountPrice * 0.18;
    window.finalPayableAmount = Math.ceil(finalDiscountPrice + finalGST);

    if (digioSignUpdate.status === "SUCCESS") {
      digioSignedUpdatePayment({
        paymentId: digioSignUpdate.details.paymentID,
        digioDesc: "Signed",
        digioDocId: digioSignUpdate.details.digio_doc_id,
        digioDocSignStatus: "success",
      }).then(() => {
        localStorage.setItem("pid", window.paymentID);
        setInitializeCashfree(true);
        setShowModal(false);
        // navigate(`/make-payment`);
        // handleScrollToTop();
        paymentOnCashFree(digioSignUpdate.details.paymentID).then(
          (response) => {
            if (response?.data?.status) {
              doPayment(response.data?.data?.payment_session_id);
            }
          }
        );
      });      
    } else if (digioSignUpdate.status === "CANCELLED") {
      setInitializeCashfree(true);
      setShowModal(false);
      cancelSignDocument(digioSignUpdate.details.digio_doc_id);
    }
  }, [digioSignUpdate.status]);

  useEffect(() => { }, [planData]);

  const submit = async (values) => {
    setHasUserDataBeforePayment(values);

    const valueClone = {
      ...values,
      total,
      gst,
      grandTotal,
      isPaymentRequest,
      paymentId,
    };
    if (Object.keys(planData)[0] == 1000 || Object.keys(planData)[0] == 1001) {
      delete valueClone.gst;
      delete valueClone.grandTotal;
    }

    let params = {
      id: Object.values(planData)[0].id,
      paymentType: isPaymentRequest
        ? "request"
        : Object.values(planData)[0].bundleName
          ? "bundle"
          : "individual", // "individual", "bundle", "request"
      cusCity: valueClone.cusCity,
      cusState: valueClone.cusState,
      cusCountry: valueClone.cusCountry,
    };
    let payload = { ...params };
    for (const key in payload) {
      if (payload[key] === "" || payload[key] === 0) delete payload[key];
    }

    return requestSignDocument(payload)
      .then((response) => {
        buttonRef.current?.click();
        setRequestSignData(response.data.data);
      })
      .catch((e) => {
        alert(e.response?.data?.message);
        // toast.error(e.response?.data?.message)
        // setHasErrorMessage(e.response?.data?.message);
      });
  };

  const validationSchema = Yup.object({
    cusCountry: Yup.string()
      .optional("Country is required")
      .max(100, "Country should be less then 100 characters."),
    cusState: Yup.string()
      .optional("State is required")
      .max(100, "State should be less then 100 characters."),
    cusCity: Yup.string()
      .optional("City is required")
      .max(100, "City should be less then 100 characters."),
  });

  const validationSchemaKyc = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .max(255, "Name should be less then 100 characters."),
    mobile: Yup.string()
      .required("Mobile is required")
      .max(255, "Mobile should be less then 100 characters."),
    email: Yup.string()
      .required("Email is required")
      .max(255, "Email should be less then 100 characters."),
    city: Yup.string()
      .required("City is required")
      .max(255, "City should be less then 100 characters."),
    country: Yup.string()
      .required("Country is required")
      .max(255, "Country should be less then 100 characters."),
    pan: Yup.string()
      .required("PAN is required")
      .max(255, "PAN should be less then 100 characters."),
    address: Yup.string()
      .required("Address is required")
      .max(255, "Address should be less then 100 characters."),
  });
  const primaryThemeButtonClass = "btn";
  const primaryThemeButtonStyle = {
    backgroundColor: "var(--bs-emphasis-color)",
    borderColor: "var(--bs-emphasis-color)",
    color: "var(--bs-body-bg)",
  };

  const secondaryThemeButtonClass = "btn";
  const secondaryThemeButtonStyle = {
    backgroundColor: "transparent",
    borderColor: "var(--bs-emphasis-color)",
    color: "var(--bs-emphasis-color)",
  };

  return (
    <>      
      <button
        disabled={componentKey !== parseInt(Object.keys(planData)[0])}
        className={`${primaryThemeButtonClass} "shine-effect w-100 fs-6"`}
        style={primaryThemeButtonStyle}
        // data-bs-toggle="modal"
        // data-bs-target="#loginModalFull"
        onClick={() => {
          localStorage.setItem(
            "cz",
            JSON.stringify({
              planData,
              componentKey,
              total,
              gst,
              grandTotal,
              isPaymentRequest,
              paymentId,
              sourceData,
              IsRecurringOptionOpen
            })
          );
          // authState ? sourceData == "AI_PORTFOLIO" ? window.location.href = "/modal-portfolio": window.location.href ="/checkout" : setOffCanvas(true)
          authState ? window.location.href = "/checkout" : setOffCanvas(true)
        }}
        // style={{ cursor: "pointer" }}
      >
        {btnName ? btnName : "Subscribe"}
      </button>
      {/* )} */}

      {/* <div className="modal fade" id="service_process" tabIndex="-1" aria-labelledby="service_processLabel"
      aria-hidden="true" data-bs-backdrop="static"> */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden={!showModal}
        style={{ display: showModal ? "block" : "none" }}
      >
        {/* <div className="modal-dialog modal-md modal-confirm modal-dialog-centered modal-dialog-scrollable"> */}
        <div className="modal-dialog">
          {/* <div className="modal-content table"> */}
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold fs-6 text-capitalize">
                {!isKycFilled ? "Proceed with agreement" : "Complete KYC"}
              </h5>
              {/* <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={buttonRef}>
            </button> */}
              <button
                type="button"
                className="btn-close btn-sm btn"
                onClick={handleClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-1 mb-2">
              <div className="row">
                {!isKycFilled ? (
                  <Formik
                    enableReinitialize
                    initialValues={{
                      cusCountry: "INDIA",
                      cusState: "",
                      cusCity: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      submit(values).then(() => {
                        setSubmitting(false);
                        resetForm();
                      });
                    }}
                  >
                    {({ isSubmitting, touched, errors, values }) => (
                      <Form>
                        <div className="row justify-content-center g-3 mt-1">
                          {Object.values(planData)[0]?.orderItems?.map(
                            (item, i) => (
                              <div
                                className="col-md-8 my-1 d-flex justify-content-between"
                                key={i}
                              >
                                <small className="">{item.name}</small>
                                <small>
                                  {item?.planDuration ||
                                    item?.duration ||
                                    item?.pacDuration}{" "}
                                  {(item?.planDuration ||
                                    item?.duration ||
                                    item?.pacDuration) > 1
                                    ? " Months"
                                    : " Month"}
                                </small>
                              </div>
                            )
                          )}
                          <div className="col-md-8 d-flex justify-content-between d-none">
                            <small className="">Duration</small>
                            <small>
                              {Object.values(planData)[0]?.planDuration ||
                                Object.values(planData)[0]?.duration}{" "}
                              {(Object.values(planData)[0]?.planDuration ||
                                Object.values(planData)[0]?.duration) > 1
                                ? "Months"
                                : "Month"}
                            </small>
                          </div>
                          <div className="col-md-8 my-1 d-flex justify-content-between">
                            <small className="fw-bold">Sub Total</small>
                            <small className="fw-bold">
                              <IndianRupee size={12} />
                              {total?.toLocaleString("en-IN")}
                            </small>
                          </div>
                          <div className="col-md-8 my-1 d-flex justify-content-between">
                            <small className="">GST (18%)</small>
                            <small>
                              <IndianRupee size={12} />
                              {gst?.toLocaleString("en-IN")}
                            </small>
                          </div>
                          <div className="col-md-8 my-1 d-flex justify-content-between fw-bold">
                            <small className="">Total</small>
                            <small>
                              <IndianRupee size={12} />
                              {grandTotal?.toLocaleString("en-IN")}
                            </small>
                          </div>
                          <div className="col-md-12 d-none">
                            <small className="d-block text-muted">Name</small>
                            <small>{userDetail.firstName}</small>
                          </div>
                          <div className="col-md-12 d-none">
                            <small className="d-block  text-muted">
                              Mobile
                            </small>
                            <small>{userDetail.mobile}</small>
                          </div>
                          {/*</div>*/}
                          {/*<div className="row g-3">*/}
                          <div className="col-md-4 col-6 d-none">
                            <small className="d-block text-muted">
                              Country
                            </small>
                            <Field
                              as="select"
                              name="cusCountry"
                              className={`form-control form-control-sm ${touched.cusCountry &&
                                errors.cusCountry &&
                                "is-invalid"
                                }`}
                              value={values.cusCountry}
                            >
                              <option value="">-- Select --</option>
                              <option value="INDIA">INDIA</option>
                              <option value="other">Other</option>
                            </Field>
                            <ErrorMessage
                              name="cusCountry"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          {values.cusCountry === "INDIA" ? (
                            <div
                              className={`col-md-8 ${userDetail.state ? "d-none" : ""
                                }`}
                            >
                              <small className="d-block text-muted">
                                Please Select Your State
                              </small>
                              <Field
                                as="select"
                                name="cusState"
                                className={`form-control form-control-sm text-center ${touched.cusState &&
                                  errors.cusState &&
                                  "is-invalid"
                                  }`}
                                // required={true}
                                value={values.cusState}
                              >
                                <option value="">--Select --</option>
                                {states.map((item, index) => (
                                  <option value={item.value} key={index}>
                                    {item.text}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="cusState"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          ) : (
                            <div className="col-md-4 col-6">
                              <small className="d-block text-muted">
                                State
                              </small>
                              <Field
                                className={`form-control form-control-sm ${touched.cusState &&
                                  errors.cusState &&
                                  "is-invalid"
                                  }`}
                                value={values.cusState}
                                name="cusState"
                              // required={true}
                              />
                              <ErrorMessage
                                name="cusState"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          )}

                          <div className="col-md-4 col-6 d-none">
                            <small className="d-block text-muted">City</small>
                            <Field
                              className={`form-control form-control-sm ${touched.cusCity &&
                                errors.cusCity &&
                                "is-invalid"
                                }`}
                              value={values.cusCity}
                              name="cusCity"
                            // required={true}
                            />
                            <ErrorMessage
                              name="cusCity"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          {!(userDetail.rpfProfileType && authState) && (
                            <div className="col-md-8 text-center">
                              <span>
                                <b className="my-2 text-danger">
                                  {hasErrorMessage}
                                </b>
                              </span>
                              <p className="my-2">
                                <hr />
                                <small className="text-body-emphasis fst-italic">
                                  {" "}
                                  Let's quickly check if{" "}
                                  <b>
                                    {Object.values(planData)[0]
                                      ?.orderItems?.map((item) => item.name)
                                      .join(", ")}
                                  </b>{" "}
                                  is right fit for you!
                                </small>
                              </p>
                              <button
                                className="btn btn-success w-100"
                                onClick={() => {
                                  navigate("/risk-profile");
                                }}
                              >
                                Continue
                              </button>
                            </div>
                          )}

                          <div
                            className={`col-md-8 ${userDetail.rpfProfileType && authState
                                ? ""
                                : "d-none"
                              }`}
                          >
                            <div className="my-2">
                              <button
                                type="submit"
                                className="btn btn-success px-3 mt-2 w-100"
                                disabled={
                                  isSubmitting ||
                                  (!userDetail.rpfProfileType && authState)
                                }
                              >
                                {isSubmitting ? "Loading..." : "Continue"}
                                {/* {!isSubmitting && <ChevronRightIcon size={20} />}
                                <i className="bi bi-arrow-right"></i> */}
                              </button>
                            </div>
                            <p></p>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <Formik
                    initialValues={{
                      userId: userDetail.id,
                      ckycNo: "-",
                      name: userDetail.firstName,
                      email: userDetail.email,
                      mobile: userDetail.mobile,
                      address: "",
                      city: hasUserDataBeforePayment.cusCity,
                      state: hasUserDataBeforePayment.cusState,
                      country: hasUserDataBeforePayment.cusCountry,
                      pan: "",
                      isCompleted: true,
                    }}
                    enableReinitialize
                    validationSchema={validationSchemaKyc}
                    onSubmit={async (values, { setSubmitting }) => {
                      await axiosInstance.post(`${V1_API_ORIGIN}/kyc`, values);
                      await buttonRef.current.click();
                      navigate("/my-services");
                      setHasUserDataBeforePayment({
                        cusCountry: "INDIA",
                        cusState: "",
                        cusCity: "",
                      });
                    }}
                  >
                    {({ isSubmitting, touched, errors, values }) => (
                      <Form>
                        <div className="row">
                          {hasKycData?.id && (
                            <div className="col-12 mb-3 text-center bg-secondary-subtle py-2">
                              Your KYC details are up to date.
                            </div>
                          )}
                          <div className="col-6 mb-2">
                            <small className="d-block">Name</small>
                            <Field
                              name="name"
                              className={`form-control form-control-sm mt-1 ${touched.name && errors.name && "is-invalid"
                                }`}
                              value={values.name}
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="col-6 mb-2">
                            <small className="d-block">Mobile</small>
                            <Field
                              name="mobile"
                              className={`form-control form-control-sm mt-1 ${touched.mobile && errors.mobile && "is-invalid"
                                }`}
                              value={values.mobile}
                            />
                            <ErrorMessage
                              name="mobile"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="col-6 mb-2">
                            <small className="d-block">Email</small>
                            <Field
                              name="email"
                              className={`form-control form-control-sm mt-1 ${touched.email && errors.email && "is-invalid"
                                }`}
                              value={values.email}
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="col-6 mb-2">
                            <small className="d-block">Country</small>
                            <Field
                              as="select"
                              name="country"
                              className={`form-control form-control-sm mt-1 ${touched.country &&
                                errors.country &&
                                "is-invalid"
                                }`}
                              value={values.country}
                            >
                              <option value="">-- Select --</option>
                              <option value="INDIA">INDIA</option>
                              <option value="">OTHER</option>
                            </Field>
                          </div>
                          {["INDIA"].includes(values.country) ? (
                            <div className="col-6 mb-2">
                              <small className="d-block">State</small>
                              <Field
                                as="select"
                                name="state"
                                className={`form-control form-control-sm mt-1 ${touched.state && errors.state && "is-invalid"
                                  }`}
                                value={values.state}
                              >
                                <option value="">-- Select --</option>
                                {states.map((item, index) => (
                                  <option value={item.value} key={index}>
                                    {item.text}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="state"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          ) : (
                            <div className="col-6 mb-2">
                              <small className="d-block">Country</small>
                              <Field
                                name="country"
                                className={`form-control form-control-sm mt-1 ${touched.country &&
                                  errors.country &&
                                  "is-invalid"
                                  }`}
                                value={values.country}
                              />
                              <ErrorMessage
                                name="country"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          )}

                          <div className="col-6 mb-2">
                            <small className="d-block">City</small>
                            <Field
                              name="city"
                              className={`form-control form-control-sm mt-1 ${touched.city && errors.city && "is-invalid"
                                }`}
                              value={values.city}
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4 col-6">
                            <small style={{ fontSize: "13px" }}>PAN</small>
                            <Field
                              name="pan"
                              className={`form-control form-control-sm mt-1 ${touched.pan && errors.pan && "is-invalid"
                                }`}
                              value={values.pan || hasKycData.pan}
                            ></Field>
                            <ErrorMessage
                              name="pan"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-12 col-12">
                            <small style={{ fontSize: "13px" }}>
                              Full Address (as per document)
                            </small>
                            <Field
                              name="address"
                              className={`form-control form-control-sm mt-1 ${touched.address &&
                                errors.address &&
                                "is-invalid"
                                }`}
                              value={values.address || hasKycData.address}
                            ></Field>
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        {!(userDetail.rpfProfileType && authState) && (
                          <div className="text-center">
                            <span>
                              <b className="my-2 text-danger">
                                {hasErrorMessage}
                              </b>
                            </span>
                            <p className="my-2">
                              <hr />
                              <small className="text-body-emphasis fst-italic">
                                {" "}
                                Let's quickly check if{" "}
                                <b>
                                  {Object.values(planData)[0]
                                    ?.orderItems?.map((item) => item.name)
                                    .join(", ")}
                                </b>{" "}
                                is right fit for you!
                              </small>
                            </p>
                            <button
                              className="btn btn-success w-100"
                              onClick={() => {
                                navigate("/risk-profile");
                              }}
                            >
                              Continue
                            </button>
                          </div>
                        )}
                        <div className="col-12 text-end">
                          <div className="my-2">
                            <button
                              type="submit"
                              className="btn btn-success px-3 w-100"
                              disabled={
                                isSubmitting ||
                                (!userDetail.rpfProfileType && authState)
                              }
                            >
                              {isSubmitting ? "Loading..." : "Proceed"}
                              {!isSubmitting && <ChevronRightIcon size={20} />}
                              <i className="bi bi-arrow-right"></i>
                            </button>
                          </div>
                          <p></p>
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {(showModal || OffCanvas) && (
        <div className="modal-backdrop fade show"></div>
      )}
      <OffCanvasRight
        section="mobile"
        sourceData={sourceData}
        pageData={pageData}
        OffCanvasToggle={handleOffCanvasToggle}
        showModal={OffCanvas}
        hasPerformance={hasPerformance}
      /> */}
    </>
  );
};
